import { render } from "./companyView.vue?vue&type=template&id=48282c48&scoped=true"
import script from "./companyView.vue?vue&type=script&lang=js"
export * from "./companyView.vue?vue&type=script&lang=js"

import "./companyView.vue?vue&type=style&index=0&id=48282c48&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48282c48"]])

export default __exports__